import React, { ReactElement } from 'react';
import { Route, HashRouter as Router } from 'react-router-dom';
import Home from './pages/home';
import ApplyReview from './pages/apply-review';
import UserList from './pages/user-list';
import Income from './pages/income';
import IncomeRecord from './pages/income-record';
import BindCard from './pages/bind-card';
import ManageCard from './pages/manage-card';
import Realization from './pages/realization';
import RealizationDetail from './pages/realization-detail';
import OrderDetail from './pages/order-detail';

const App = (): ReactElement => {
  return (
    <Router>
      <Route path="/" exact component={Home} />
      <Route path="/apply-review" exact component={ApplyReview} />
      <Route path="/user-list" exact component={UserList} />
      <Route path="/income" exact component={Income} />
      <Route path="/income-record" exact component={IncomeRecord} />
      <Route path="/bind-card" exact component={BindCard} />
      <Route path="/manage-card" exact component={ManageCard} />
      <Route path="/realization" exact component={Realization} />
      <Route path="/realization-detail" exact component={RealizationDetail} />
      <Route path="/order-detail" exact component={OrderDetail} />
    </Router>
  );
};

export default App;
